import { render, staticRenderFns } from "./LoadingList.vue?vue&type=template&id=456d77fe&scoped=true&"
import script from "./LoadingList.vue?vue&type=script&lang=ts&"
export * from "./LoadingList.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingList.vue?vue&type=style&index=0&id=456d77fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d77fe",
  null
  
)

export default component.exports